const getInitConfig = () => {
  return {
    network: getNetworkConfig(),
  }
}

const getNetworkConfig = () => {
  return {
    requestSanitizer: (request) => {
      if (request.url.toLowerCase().indexOf('login') !== -1) {
        return null
      }

      request.headers.Authorization = null

      return request
    },
  }
}

export default getInitConfig
